import { render } from "./PaymentResult.vue?vue&type=template&id=17516f88&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"

import "./PaymentResult.vue?vue&type=style&index=0&id=17516f88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17516f88"

export default script